import { connect } from "react-redux";
import SettingsComponent from "../components/Settings.Component";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);
